module.exports = __webpack_public_path__ + "static/img/hr_visitor_benefit_top_bg.3365990b.png";